// src/firebase.ts
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBZwhjdM74EvgWYmB7GmHWGZW2c1WQz2uM",
  authDomain: "morrisyluna.firebaseapp.com",
  projectId: "morrisyluna",
  storageBucket: "morrisyluna.appspot.com",
  messagingSenderId: "871345265853",
  appId: "1:871345265853:web:b8608665f61dd5a5e22bd4",
  measurementId: "G-T5TL4ZV0R7"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
